<template>
  <div class="editor-wrapper">
    <div :id="editorId" style="height:96%"></div>
  </div>
</template>

<script>
import Editor from "wangeditor";
import "wangeditor/release/wangEditor.min.css";
import { oneOf } from "@/libs/tools";
import { getToken } from "@/libs/util";
import { uploadImg } from "@/api/public";
export default {
  name: "Editor",
  props: {
    value: {
      type: String,
      default: ""
    },
    /**
     * 绑定的值的类型, enum: ['html', 'text']
     */
    valueType: {
      type: String,
      default: "html",
      validator: val => {
        return oneOf(val, ["html", "text"]);
      }
    },
    /**
     * @description 设置change事件触发时间间隔
     */
    changeInterval: {
      type: Number,
      default: 200
    },
    /**
     * @description 是否开启本地存储
     */
    cache: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    editorId() {
      return `editor${this._uid}`;
    }
  },
  methods: {
    setHtml(val) {
      this.editor.txt.html(val);
    }
  },
  mounted() {
    this.editor = new Editor(`#${this.editorId}`);
    this.editor.customConfig.onchange = html => {
      let text = this.editor.txt.text();
      if (this.cache) localStorage.editorCache = html;
      this.$emit("input", this.valueType === "html" ? html : text);
      this.$emit("on-change", html, text);
    };
    // this.editor.customConfig.uploadImgShowBase64 = true;
    let that = this;
    this.editor.customConfig.customUploadImg = function(files, insert) {
      if (files.length) {
        for (var i = 0; i < files.length; i++) {
          let data = new FormData();
          data.append("file", files[i]); // 文件对象
          uploadImg(data).then(res => {
            if (res.data.code == 0) {
              insert(that.$globalUrl + res.data.payload);
            } else {
              that.$Message["error"]({
                background: true,
                content: res.data.msg,
                duration: 5
              });
            }
          });
        }
      }
      // files 是 input 中选中的文件列表
      // insert 是获取图片 url 后，插入到编辑器的方法

      // 上传代码返回结果之后，将图片插入到编辑器中
      // insert(imgUrl);
    };
    this.editor.customConfig.onchangeTimeout = this.changeInterval;
    this.editor.customConfig.menus = [
      "head", // 标题
      "bold", // 粗体
      "fontSize", // 字号
      "fontName", // 字体
      "italic", // 斜体
      "underline", // 下划线
      "strikeThrough", // 删除线
      "foreColor", // 文字颜色
      "backColor", // 背景颜色
      "link", // 插入链接
      "list", // 列表
      "justify", // 对齐方式
      // "quote", // 引用
      "emoticon", // 表情
      "image", // 插入图片
      "table", // 表格
      "video", // 插入视频
      // "code", // 插入代码
      "undo", // 撤销
      "redo" // 重复
    ];
    // create这个方法一定要在所有配置项之后调用
    this.editor.create();
    // 如果本地有存储加载本地存储内容
    let html = this.value || localStorage.editorCache;
    if (html) this.editor.txt.html(html);
  }
};
</script>

<style lang="less">
.editor-wrapper {
  height: 50vh;
}
.editor-wrapper * {
  z-index: 100 !important;
}
.w-e-text-container {
  height: 90% !important;
}
.w-e-menu {
  z-index: 101 !important;
}
</style>
